import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "px-5 pb-5 container d-flex justify-content-between" }
const _hoisted_2 = { class: "container-sections col-4" }
const _hoisted_3 = { class: "header d-flex justify-content-between align-itens-center col" }
const _hoisted_4 = { class: "m-0" }
const _hoisted_5 = { class: "content-menu card flex justify-content-center mt-3" }
const _hoisted_6 = { class: "menu-steps w-75" }
const _hoisted_7 = { class: "menu-list" }
const _hoisted_8 = { class: "menu-item" }
const _hoisted_9 = { class: "menu-item-label" }
const _hoisted_10 = { class: "menu-item" }
const _hoisted_11 = { class: "menu-item-label" }
const _hoisted_12 = { class: "container-information col-10" }
const _hoisted_13 = { class: "header d-flex justify-content-end align-itens-end mt-3" }
const _hoisted_14 = { class: "container-computer mt-3" }
const _hoisted_15 = { class: "selected-computers d-flex justify-content-between align-itens-center p-3" }
const _hoisted_16 = { class: "fw-bold m-0" }
const _hoisted_17 = {
  id: "group-form",
  class: "form mb-3"
}
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "form-group w-50" }
const _hoisted_20 = { for: "addOrgs" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "mb-3" }
const _hoisted_23 = {
  key: 1,
  class: "computer-cards"
}
const _hoisted_24 = { class: "d-flex justify-content-between" }
const _hoisted_25 = { class: "computer-name mb-3" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "mb-3 justify-content-between" }
const _hoisted_28 = { class: "w-50" }
const _hoisted_29 = { class: "computer-anydesk w-50" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_ds_button = _resolveComponent("ds-button")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ConfirmDialog),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.groupId ? `Editar Grupo` : `Adicionar Grupo`), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("ul", _hoisted_7, [
            _createElementVNode("li", _hoisted_8, [
              _createElementVNode("a", {
                class: _normalizeClass(["menu-item-link", {'active': _ctx.$route.name === 'AddGroup'}]),
                onClick: _cache[0] || (_cache[0] = () => _ctx.$router.push({name: 'editGroup', params: {groupId: _ctx.groupId} }))
              }, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('group.fields.info')), 1)
              ], 2)
            ]),
            _createElementVNode("li", _hoisted_10, [
              _createElementVNode("a", {
                class: _normalizeClass(["menu-item-link", {'active': _ctx.$route.name === 'addGroupOrganization'}]),
                onClick: _cache[1] || (_cache[1] = () => _ctx.$router.push({name: 'addGroupOrganization', params: {groupId: _ctx.groupId} }))
              }, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('group.fields.addOrganization')), 1)
              ], 2)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_ds_button, {
          type: "primary",
          text: _ctx.$t('utils.save'),
          class: "float-start col-sm-2 me-3",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sendGroup()))
        }, null, 8, ["text"])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('group.fields.lenOrgs')) + ": " + _toDisplayString(_ctx.group.organizationAccess.length), 1)
        ]),
        _createElementVNode("form", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('group.fields.addOrganization')), 1),
              _createVNode(_component_AutoComplete, {
                placeholder: _ctx.$t('group.fields.selectOrg'),
                dropdown: "",
                modelValue: _ctx.pickedOrganization,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pickedOrganization) = $event)),
                suggestions: _ctx.organizations,
                onComplete: _ctx.getOrganizations,
                onItemSelect: _ctx.addNewOrganization,
                field: "name",
                required: ""
              }, null, 8, ["placeholder", "modelValue", "suggestions", "onComplete", "onItemSelect"])
            ])
          ])
        ]),
        (_ctx.group.organizationAccess.length == 0 )
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("h4", _hoisted_22, _toDisplayString(_ctx.$t('group.fields.noOrgsAdded')), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_23, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.group.organizationAccess, (org, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "computer-div p-3 mb-3",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("h4", _hoisted_25, _toDisplayString(org.name), 1),
                    (index !== 0)
                      ? _withDirectives((_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "material-icons delete-icon",
                          onClick: ($event: any) => (_ctx.confirmeRemove(org.id))
                        }, [
                          _createTextVNode(" delete ")
                        ], 8, _hoisted_26)), [
                          [
                            _directive_tooltip,
                            _ctx.$t('utils.delete'),
                            void 0,
                            { bottom: true }
                          ]
                        ])
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createTextVNode("Status: "),
                      _createElementVNode("span", {
                        class: _normalizeClass('computer-status status-' + org.status)
                      }, _toDisplayString(org.status ? _ctx.$t('utils.active') : _ctx.$t('utils.inactive')), 3)
                    ]),
                    _createElementVNode("div", _hoisted_29, "CNPJ: " + _toDisplayString(org.cnpj), 1)
                  ])
                ]))
              }), 128))
            ]))
      ])
    ])
  ]))
}